import AMBKingSportBonus from './AMBKingSportBonus'

export default AMBKingSportBonus
